"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEMA_FORMATS = void 0;
/**
 * Built-in schema formats
 */
exports.SCHEMA_FORMATS = {
    DATE: 'date',
    DATE_TIME: 'date-time',
    EMAIL: 'email',
    URI: 'uri',
    UUID: 'uuid'
};
